import { contentActions } from '../../../actions/content/content'
import { responseHandlerService } from '@/plugins/responseHandlerService'
import axios from '@/plugins/axiosInstance'

/**
 * Generate content based on trend data
 * @param {Object} data - Trend data and parameters
 * @param {Object} assetStore - Asset store instance
 * @param {Object} dependencies - Dependencies including state and translation function
 * @returns {Promise<Object>} Generated content
 */
export const generateTrendContent = async (data, assetStore, dependencies) => {
  const { state, t } = dependencies
  
  // Validate required inputs
  if (!data || !data.trend || !assetStore || !assetStore.assetId) {
    responseHandlerService.handleError(t('socialMedia.components.createPost.errors.missingData'))
    return false
  }

  // Check if already generating content
  if (state.isGenerating.value) {
    return false
  }

  try {
    // Prepare state for generation
    state.isGenerating.value = true
    
    // Backup current content if exists
    if (state.generatedContent.value) {
      state.previousContent.value = JSON.parse(JSON.stringify(state.generatedContent.value))
    }
    
    // Create cancel token
    state.cancelTokenSource.value = axios.CancelToken.source()
    
    // Save generation parameters for potential regeneration
    state.lastGenerationParams.value = {
      type: 'trend',
      data: JSON.parse(JSON.stringify(data)),
    }
    
    // Call the API action
    const content = await contentActions.generateContentFromTrend(
      data,
      assetStore.assetId,
      state.cancelTokenSource.value.token
    )
    
    // Update state with generated content
    if (content) {
      state.generatedContent.value = content
      responseHandlerService.handleSuccess(t('socialMedia.components.createPost.success.contentGenerated'))
      return true
    }
    
    return false
  } catch (error) {
    // Error handling for non-cancel errors
    if (!axios.isCancel(error)) {
      responseHandlerService.handleError(t('socialMedia.components.createPost.errors.generateContent'))
    }
    return false
  } finally {
    // Clear generation state
    state.isGenerating.value = false
    state.cancelTokenSource.value = null
  }
}
